import { render, staticRenderFns } from "./VideoPlayer.vue?vue&type=template&id=197c6d3f&scoped=true"
import script from "./VideoPlayer.vue?vue&type=script&lang=ts"
export * from "./VideoPlayer.vue?vue&type=script&lang=ts"
import style0 from "./VideoPlayer.vue?vue&type=style&index=0&id=197c6d3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197c6d3f",
  null
  
)

export default component.exports